import { useEffect } from "react";

import PuffLoader from "react-spinners/PuffLoader";

import '../global.css';
import '../styles/shared/loading.css';

interface LoadingProps {
    text?: string;
}

const Loading: React.FC<LoadingProps> = ({ text }) => {

    useEffect(() => {
        const ring = document.getElementById('loader');
        if (ring) {
            const children = ring.children;
            for (const child of Array.from(children)) {
                if (child instanceof HTMLElement) {
                    child.style.border = "1.25vh solid rgb(253, 230, 166)";
                    child.style.width = "48.75vh";
                    child.style.height = "48.75vh";
                }
            }
        }
    }, []);

    return (
        <div className="loading_background">
            <PuffLoader
                color={"rgb(253, 230, 166)"}
                loading={true}
                size={"50vh"}
                speedMultiplier={0.5}
                aria-label="Loading Spinner"
                data-testid="loader"
                id="loader"
            />
            {text && (
                <div className="loading_text">
                    {text}
                </div>
            )}
        </div>
    );
};

export default Loading;

